import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: '',
    preferredCourseId: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    
    if (!/^[0-9]{10}$/.test(formData.mobile)) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }

    setLoading(true);
    setError('');

    const result = await register({
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      mobile: formData.mobile,
      password: formData.password,
      preferredCourseId: formData.preferredCourseId || 1
    });
    
    if (result.success) {
      navigate('/');
    } else {
      setError(result.message);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center pt-32 pb-16 px-4">
      <div className="w-full max-w-lg">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-block mb-6">
            <img 
              src="/logo.png" 
              alt="BESST" 
              className="h-20 w-auto object-contain mx-auto"
            />
          </Link>
          <h1 className="text-3xl font-bold text-white mb-2">Create Account</h1>
          <p className="text-text-muted">Start your learning journey with BESST</p>
        </div>

        {/* Register Form */}
        <div className="glass-card">
          {error && (
            <div className="bg-red-500/20 text-red-400 p-4 rounded-xl mb-6">
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="grid grid-cols-2 gap-4">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                className="form-input"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                className="form-input"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
            
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              required
            />
            
            <input
              type="tel"
              name="mobile"
              placeholder="Mobile Number (10 digits)"
              className="form-input"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
            
            <select
              name="preferredCourseId"
              className="form-input"
              value={formData.preferredCourseId}
              onChange={handleChange}
            >
              <option value="">Select Course of Interest</option>
              <option value="1">CUET-UG</option>
              <option value="2">JEE Main & Advanced</option>
              <option value="3">NEET</option>
              <option value="4">Foundation Course</option>
            </select>
            
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Password (min 6 characters)"
                className="form-input pr-12"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="absolute right-4 top-1/2 -translate-y-1/2 text-text-muted hover:text-white"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            
            <input
              type={showPassword ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="Confirm Password"
              className="form-input"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            
            <label className="flex items-start gap-3 cursor-pointer">
              <input 
                type="checkbox" 
                className="w-4 h-4 mt-1 rounded border-glass-border bg-glass-bg text-accent-gold"
                required 
              />
              <span className="text-text-muted text-sm">
                I agree to the{' '}
                <Link to="/terms" className="text-accent-gold hover:underline">Terms of Service</Link>
                {' '}and{' '}
                <Link to="/privacy" className="text-accent-gold hover:underline">Privacy Policy</Link>
              </span>
            </label>
            
            <button 
              type="submit" 
              className="btn-primary w-full"
              disabled={loading}
            >
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>

          {/* Divider */}
          {/* <div className="relative my-8">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-glass-border"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-transparent text-text-muted">Or sign up with</span>
            </div>
          </div> */}

          {/* Social Login */}
          {/* <div className="grid grid-cols-2 gap-4">
            <button className="glass rounded-xl py-3 px-4 flex items-center justify-center gap-2 text-white hover:border-accent-gold transition-all">
              <span>📧</span> Google
            </button>
            <button className="glass rounded-xl py-3 px-4 flex items-center justify-center gap-2 text-white hover:border-accent-gold transition-all">
              <span>📘</span> Facebook
            </button>
          </div> */}

          {/* Sign In Link */}
          <p className="text-center mt-8 text-text-muted">
            Already have an account?{' '}
            <Link to="/login" className="text-accent-gold font-semibold hover:underline">
              Sign In
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;